export const environment = {
  production: false,
  apiUrl: 'https://dev-back.mysportapp.co/api',
  webDomain: 'https://dev.mysportapp.co',
};
